import React, { useEffect, useState } from "react";
import TableHeader from "../../common/table/TableHeader";
import TableSkeleton from "../../common/table/TableSkeleton";
import handleError from "../../../constant/handleError";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import useShowAlert from "../../../utils/AlertUtiles";
import axiosInstance from "../../../utils/AxiosInstance";
import ReactPaginate from "react-paginate";
import DateConverter from "@heartinz/date_and_time_processor";
import uRLs from "../../../utils/baseUtils";
import { capitalizeFirstLetter } from "../../../utils/helper";
import ViewInterest from "./ViewInterest";

const headers = [
  "S.No",
  "Interest No",
  "Phone",
  "State",
  "District",
  "Work Date",
  "No Of Acres ",
  "Amount",
  "Status",
];

function Interest() {
  const [loading, setLoading] = useState({  
    list: false,    
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isBookingData, setBooking] = useState([]);
  const [isSelectedData, setSelectedData] = useState({});
  const [isViewModelOpen, setViewModalOpen] = useState(false);
  
  const showAlert = useShowAlert();

  const hadlelistInterest = async (page = 0) => {
    setLoading((prev) => ({ ...prev, list: true }));
    checkNetworkStatus();

    try {
         
      const response = await axiosInstance.get(`farmerbooking/admin/interest/detail?pageno=${page + 1}&limit=${uRLs.PER_PAGE}`);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {
        setBooking(response?.data?.results);
      } else {
        setBooking([]);
      }

      if (response?.data?.results?.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response?.data.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      setBooking([]);
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, list: false }));
    }
  };

  useEffect(() => {
    hadlelistInterest(currentPage);
  }, [currentPage]);

  const handleViewBooking = async (item) => {  
    setSelectedData(item)
    setViewModalOpen(true);   
  };
  const handleCloseViewBooking = async () => {
    setViewModalOpen(false);   
  };
 
  return (
    <div>
      <div className=" pe-3">
        <div class="breadcrumb-title pe-3 mb-3">Old Enquiries</div>
      </div>
     

      <div className="col-col-12 ">
        <div className="card mb-0">
          <div className="card-body p-0">
            <div className="table-responsive scrollable-table-container">
              <table className="table align-middle mb-0  ">
                <TableHeader headers={headers} />

                <tbody>
                  {loading.list ? (
                    <TableSkeleton
                      rows={5}
                      columns={[100,100, 100, 200, 200, 100, 100, 100, 100]}
                    />
                  ) : Array.isArray(isBookingData) &&
                    isBookingData.length > 0 ? (
                    isBookingData.map((item, index) => (
                      <tr
                        key={item._id || index}
                        onClick={() => {
                          handleViewBooking(item);
                        }}
                        className="position-relative  cursor-poInter hover-row"
                      >
                      <td className="text-center">{totalItems - (currentPage * uRLs.PER_PAGE + index)}</td>  
                      <td className="text-center">{item?.interestNumber||"-"}</td>  
                        <td>
                          <p className="mb-0 text-center fw-bold">
                             {item?.mobileNumber}
                          </p>
                        </td>
                        <td className="text-center">
                          {capitalizeFirstLetter(item?.state)}
                        </td>
                        <td className="text-center">
                          {capitalizeFirstLetter(item?.district)}
                        </td>
                        <td className="text-center">
                          <div className="">
                            <p className="mb-0">
                              {item?.workStartDate
                                ? DateConverter.ISOToDisplayFormat(
                                    DateConverter.convertToTimeZone(
                                      item?.workStartDate,
                                      uRLs.TIMEZONE
                                    )
                                  ).date || ""
                                : ""}
                            </p>
                          </div>
                        </td>
                        <td className="text-center">
                          <span class="badge rounded-pill bg-label-fall">
                            {item?.numberOfAcres}
                          </span>
                        </td>
                        <td>
                          <div className="text-center">
                            <p className="mb-0 fw-bold">
                              ₹
                              {
                                item?.totalAmount || 0
                              }
                            </p>
                          </div>
                        </td>                       
                        <td className="text-center">
                          {item?.lastStatus === "PLACED" &&                     
                            (
                               <span className="app-badge bg-label-warning">
                              Placed
                            </span>
                            )}

                          {item?.lastStatus === "ACCEPTED" && (
                            <span className="app-badge bg-label-spring">
                              Order processing
                            </span>
                          )}
                           {item?.lastStatus === "PAYMENT" && (
                            <span className="app-badge bg-label-moon  ">
                              Payment
                            </span>
                          )}
                        </td>
                          

                        {/* <td className="text-center">
                          {item?.paymentStatus === "UNPAID" && (
                            <div className="card-lable bg-label-blue bg-opacity-10 d-inline-block">
                              <p className=" mb-0">Unpaid</p>
                            </div>
                          )}
                          {item?.paymentStatus === "PAID" && (
                            <div className="card-lable bg-success text-success bg-opacity-10 d-inline-block">
                              <p className="text-success mb-0">Paid</p>
                            </div>
                          )}
                        </td> */}
                        {/* <td className="text-center">
                          <div className=" d-flex justify-content-center order-actions">
                            <button
                              type="button"
                              className="btn-label-primary shadow-none me-2"
                              onClick={() => {
                                handleViewBooking(item);
                              }}
                            >
                              <i className="lni lni-eye"></i>
                            </button>
                          </div>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center p-2 text-muted">
                        <span className="text-muted">
                          No data available .
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>{" "}
            {totalPages > 0 && (
              <div className="d-flex justify-content-center mt-3">
                <ReactPaginate
                  previousLabel={"← Previous"}
                  nextLabel={"Next →"}
                  breakLabel={"..."}
                  onPageChange={({ selected }) => {
                    setLoading((prev) => ({ ...prev, list: true }));
                    setCurrentPage(selected);
                  }}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  containerClassName="pagination"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  activeClassName="active"
                  forcePage={currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {isViewModelOpen && (
        <ViewInterest
          onClose={handleCloseViewBooking}
          isSelectedData={isSelectedData}
          setSelectedData={setSelectedData}                
          setBooking={setBooking}      
         />
      )}
    </div>
  );
}

export default Interest;
